<template>
    <div id="estimado-acumulado-main" class="white rounded-xl">
      <div id="generales-contratos" class="pa-5 text-uppercase">
      <v-row>
        <v-col
          cols="4">
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              CONTRATO:
            </v-col>
            <v-col
              cols="6">
              {{ contrato.numero }}
            </v-col>
          </v-row>
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              CONTRATISTA:
            </v-col>
            <v-col
              cols="6">
              {{ contrato.contratista.nombreRazonSocial }}
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="4">
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              FORMULADA EL:
            </v-col>
            <v-col
              cols="6">
              {{ estimacion.fechaAutorizacion }}
            </v-col>
          </v-row>
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              PERIODO DEL:
            </v-col>
            <v-col
              cols="6">
              {{ new Date(`${getDatosModificados.fechaInicio} 00:00:0`)
                .toLocaleDateString('es-MX', { year: 'numeric',
                    month: 'long', day: 'numeric' }) }}
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="4">
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              ESTIMACIÓN NO.
            </v-col>
            <v-col
              cols="6">
              <v-chip
                color="base4">
                {{ estimacion.numero }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              AL:
            </v-col>
            <v-col
              cols="6">
              {{ new Date(`${estimacion.fechaAl} 00:00:0`)
                .toLocaleDateString('es-MX', { year: 'numeric',
                    month: 'long', day: 'numeric' }) }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="3"
          class="font-weight-bold">
            <span
              v-if="contrato.esObraFinanciada">
              IMPORTE DEL CONTRATO A COSTO DIRECTO:
              </span>
              <span
              v-if="!contrato.esObraFinanciada">
              IMPORTE DEL CONTRATO:
              </span>
        </v-col>
        <v-col
          cols="3" class="align-left">
          <span class="text-subtitle-1 font-weight-bold">
            {{ importeDelContrato | currency }}
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="3"
          class="font-weight-bold">
          <span class="">
              ESTIMADO:
          </span>
        </v-col>
        <v-col
          cols="3" class="align-left">
          <span class="text-subtitle-1 font-weight-bold">
          {{ totalEstimado | currency }}</span>
          <span>
          ({{porcentajeEstimadoDelImporteACostoDirecto}} % del contrato)
          </span>
        </v-col>
      </v-row>

    </div>
    <div id="grafica-estimado-acumulado" class="white rounded-xl"
    style="">
      <v-row>
        <v-col cols="5" style="text-xs-center">
          <v-simple-table>
            <template v-slot:default>
            <thead>
            <tr class="base4">
              <th class="text-center">
                    Concepto
              </th>
              <th class="text-center">
                  Importe Estimado
              </th>
              <th class="text-center">
                  %
              </th>
            </tr>
            </thead>
            <tbody>
              <tr class="text-center"
                  v-for="(item,index) in generaPuntosGrafica()"
                  :key="index">
              <td class="text-subtitle-2" >
                <v-chip
                v-bind:color="item.color">
                {{ item.concepto }}
              </v-chip>
              </td>
              <td >
                {{ item.importeConFormato }}
              </td>
              <td>
                {{ item.importePorcentaje }} %
              </td>
              </tr>
              <tr class="base4 text-center font-weight-bold">
                <td>Total</td>
                <td> {{ totalEstimado | currency}}</td>
                <td>100 %</td>
              </tr>

            </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-col cols="7">
           <pie-chart
          :chartData="dataGrafica"
          :options="options">
          </pie-chart>
        </v-col>
      </v-row>
    </div>
    </div>
</template>

<script>
import PieChart from '@/components/charts/PieChart';
import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  name: 'estimadoAcumuladoMain',
  props: {
    estimacion: {
      type: Object,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    estimaciones: {
      type: Array,
      required: true,
    },
    convenios: {
      type: Array,
      required: true,
    },
  },
  mixins: [
    mixGenerarPdf,
    mixFormatoEstructura,
  ],
  data() {
    return {
      dataGrafica: {},
      tablaGrafica: [],
      totalEstimado: 0,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'IMPORTE ESTIMADO ACUMULADO',
          font: {
            size: 16,
          },
        },
        legend: {
          display: false,
          position: 'bottom',
          onClick: null,
        },
      },
    };
  },
  components: {
    PieChart,
  },
  mounted() {
    this.getDataPieChart();
    this.generaPuntosGrafica();
  },
  watch: {
    estimacion() {
      this.getDataPieChart();
    },
  },
  computed: {
    getContratoConvenios() {
      if (!this.convenios) return [];
      return this.convenios;
    },
    getDatosModificados() {
      const datosModificados = {
        fechaInicio: '',
        fechaTermino: '',
        importe: 0,
        importeCostoDirecto: 0,
        iva: 0,
        total: 0,
      };
      let fechaXMonto = '';
      let fechaXPlazo = '';
      this.getContratoConvenios
        .forEach((c) => {
          if (c.tipo === 'PLAZO') {
            if (c.fecha >= fechaXPlazo || fechaXPlazo === '') {
              datosModificados.fechaInicio = c.fechaInicio;
              datosModificados.fechaTermino = c.fechaTermino;
              fechaXPlazo = c.fecha;
            }
          }
          if (c.tipo === 'MONTO - AMPLIACIÓN') {
            if (c.fecha >= fechaXMonto || fechaXMonto === '') {
              datosModificados.importeCostoDirecto += c.importeCostoDirecto;
              datosModificados.importe += c.importe;
              fechaXMonto = c.fecha;
            }
          }
          if (c.tipo === 'MONTO - REDUCCIÓN') {
            if (c.fecha >= fechaXMonto || fechaXMonto === '') {
              datosModificados.importeCostoDirecto += c.importeCostoDirecto;
              datosModificados.importe += c.importe;
              fechaXMonto = c.fecha;
            }
          }
          if (c.tipo === 'REPROGRAMACIÓN') {
            if (c.fecha >= fechaXPlazo || fechaXPlazo === '') {
              datosModificados.fechaInicio = c.fechaInicio;
              datosModificados.fechaTermino = c.fechaTermino;
              fechaXPlazo = c.fecha;
            }
          }
          if (c.tipo === 'PLAZO - MONTO AMPLIACIÓN') {
            if (c.fecha >= fechaXPlazo || fechaXPlazo === '') {
              datosModificados.fechaInicio = c.fechaInicio;
              datosModificados.fechaTermino = c.fechaTermino;
              fechaXPlazo = c.fecha;
            }
            if (c.fecha >= fechaXMonto || fechaXMonto === '') {
              datosModificados.importeCostoDirecto += c.importeCostoDirecto;
              datosModificados.importe += c.importe;
              fechaXMonto = c.fecha;
            }
          }
        });
      return {
        fechaInicio: datosModificados.fechaInicio,
        fechaTermino: datosModificados.fechaTermino,
        importeCostoDirecto:
        datosModificados.importeCostoDirecto + this.contrato.importeCostoDirecto,
        importe: datosModificados.importe + this.contrato.importe,
      };
    },

    porcentajeEstimadoDelImporteACostoDirecto() {
      return `${this.$numberRound((this.totalEstimado / this.importeDelContrato) * 100)}`;
    },
    importeDelContrato() {
      let importe = 0;
      if (!this.contrato.esObraFinanciada) {
        importe = this.getDatosModificados.importe || 0;
      } else {
        importe = this.getDatosModificados.importeCostoDirecto || 0;
      }
      return importe;
    },
    conceptosConLosExcedentes() {
      const estimacionesList = this.estimaciones
        .filter(({ numero }) => numero <= this.estimacion.numero)
        .map((e) => e.conceptos)
        .flat();
      let estimacionesConceptosId = estimacionesList
        .map((c) => c.idConcepto);
      estimacionesConceptosId = new Set(estimacionesConceptosId).values();
      estimacionesConceptosId = [...estimacionesConceptosId];
      const conceptosAcumulado = estimacionesConceptosId.map((c) => {
        const conceptosList = estimacionesList.filter((concepto) => concepto.idConcepto === c);
        const contratadosList = conceptosList.map((contratado) => contratado.concepto);
        const esFp = !((contratadosList[0].cantidad ? contratadosList[0].cantidad : -1) > 0);
        return {
          idConcepto: c,
          cantidad: 0,
          cantidadEstimada: this.$ObjSumar(conceptosList, 'cantidad'),
          cantidadContratada: contratadosList[0].cantidad || 0,
          precioUnitario: contratadosList[0].precioUnitario || 0,
          importe: (this.$ObjSumar(conceptosList, 'cantidad')) * (contratadosList[0].precioUnitario || 0),
          esFp,
        };
      });

      return conceptosAcumulado
        .map((concepto) => {
          let existeExcedente = false;
          const { cantidadContratada } = concepto;
          const { cantidadEstimada } = concepto;
          let cantidadExcedente = 0;
          let importeExcedente = 0;

          if (cantidadContratada > 0 && cantidadEstimada > cantidadContratada) {
            existeExcedente = true;
            const diferencia = cantidadEstimada - cantidadContratada;
            cantidadExcedente = diferencia;
            importeExcedente = this.$numberRound((
              cantidadExcedente * concepto.precioUnitario));
          }

          return {
            ...concepto,
            cantidadExcedente,
            importeExcedente,
            existeExcedente,
          };
        });
    },
  },
  methods: {
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdf() {
      this.$emit('generando');
      const nombreTemplate = 'templateGraficaEstimadoAcumulado';
      const contratoConFormato = this.formatoObjeto(this.contrato);
      const estimacionConFormato = this.formatoObjeto(this.estimacion);
      const datosModificadosConFormato = this.formatoObjeto(this.getDatosModificados);
      const encabezadoReferencia = this
        .mixGeneraEncabezadosPdf(`${this.estimacion.fechaPresentacion} 00:00:0`, []);

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
          },
          nombreTemplate,
        },
        data: {
          contrato: contratoConFormato,
          estimacion: estimacionConFormato,
          grafica:
          {
            data: this.dataGrafica.datasets[0].data,
            conceptos: this.dataGrafica.labels,

          },
          tabla: this.tablaGrafica,
          totalEstimado: this.totalEstimado
            .toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          importeDelContrato: this.importeDelContrato
            .toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          datosModificados: datosModificadosConFormato,
          porcentajeEstimadoDelImporteACostoDirecto: this.porcentajeEstimadoDelImporteACostoDirecto,
          encabezadoReferencia,
        },
      }, `${this.contrato.numero}_GraficaEstimadoAcumulado_${this.estimacion.numero}`);
      this.generandoPdfGraficaEstimadoAcumulado = false;
      this.$emit('terminando');
    },
    getDataPieChart() {
      const grafica = this.generaPuntosGrafica();
      const data = {
        labels: grafica.map(({ concepto }) => concepto),
        datasets: [{
          data: grafica.map(({ importe }) => importe),
          borderWidth: 1,
          backgroundColor: grafica.map(({ color }) => color),
          borderColor: ['#fff', '#fff', '#fff'],
          hoverBackgroundColor: grafica.map(({ colorHover }) => colorHover),
        }],
      };
      this.dataGrafica = data;
      this.tablaGrafica = this.generaPuntosGrafica();
      this.totalEstimado = this.$ObjSumar(this.tablaGrafica, 'importe');
    },

    generaPuntosGrafica() {
      if (!this.conceptosConLosExcedentes) return [];
      // Listado de conceptos normales
      const conceptosNormales = this.conceptosConLosExcedentes
        .filter((c) => c.existeExcedente === false && c.esFp === false);
      // Listado de conceptos con excedente
      const conceptosConExcedentes = this.conceptosConLosExcedentes
        .filter(({ existeExcedente }) => existeExcedente === true);
      // Listado de conceptos FPs
      const conceptosFps = this.conceptosConLosExcedentes
        .filter(({ esFp }) => esFp === true);
      const importeNormal = (this.$ObjSumar(conceptosNormales, 'importe')
          + (this.$ObjSumar(conceptosConExcedentes, 'importe')
          - this.$ObjSumar(conceptosConExcedentes, 'importeExcedente')));
      const importeExcedente = this.$ObjSumar(conceptosConExcedentes, 'importeExcedente');
      const importeFp = this.$ObjSumar(conceptosFps, 'importe');
      const estimadoTotal = importeNormal + importeExcedente + importeFp;

      return [
        {
          orden: 1,
          concepto: 'OBRA NORMAL',
          importe: importeNormal,
          importeConFormato: `$${importeNormal
            .toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }`,
          importePorcentaje: this.$numberRound(100
          - this.$numberRound((importeExcedente / estimadoTotal) * 100)
          - this.$numberRound((importeFp / estimadoTotal) * 100)),
          estimadoTotal,
          observaciones: '',
          color: '#74b782',
          colorHover: '#5fc776',
        },
        {
          orden: 2,
          concepto: 'OBRA EXCEDENTE',
          importe: importeExcedente,
          importeConFormato: `$${importeExcedente
            .toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
          importePorcentaje: this.$numberRound((importeExcedente / estimadoTotal) * 100),
          estimadoTotal,
          observaciones: '',
          color: '#FEC240',
          colorHover: '#fab31a',
        },
        {
          orden: 3,
          concepto: 'OBRA FUERA DE PRESUPUESTO',
          importe: importeFp,
          importeConFormato: `$${importeFp
            .toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
          importePorcentaje: this.$numberRound((importeFp / estimadoTotal) * 100),
          estimadoTotal,
          observaciones: '',
          color: '#FA8B00',
          colorHover: '#f59d2f',
        },
      ];
    },
  },
};
</script>
